/**
 * FlahaSOIL v2 — Water retention curve chart adapter (Phase 10C-D).
 */
import type { WaterRetentionAnalysisBlock } from "@flaha/shared-types";
import type { ScientificChartData, ScientificChartStatus } from "../types/ScientificChartTypes";
import { CHART_UNITS } from "../utils/chartUnits";

export function waterRetentionChartAdapter(
  retention: WaterRetentionAnalysisBlock | null
): ScientificChartData<WaterRetentionAnalysisBlock | null> {
  const warnings: string[] = [];
  let status: ScientificChartStatus = "READY";

  if (!retention) {
    status = "MISSING_DATA";
  }

  const title = "Soil Water Retention Curve";
  const description = "Relationship between matric potential (tension) and volumetric water content.";
  const source = "Saxton & Rawls (2006) Pedotransfer Functions";

  let accessibilitySummary = "Soil water retention curve chart.";
  if (retention) {
    accessibilitySummary = `Water retention curve for ${retention.textureClass}. Field Capacity: ${retention.fieldCapacity.waterContentVolPercent.toFixed(1)}%, Wilting Point: ${retention.wiltingPoint.waterContentVolPercent.toFixed(1)}%.`;
  } else {
    accessibilitySummary = "No water retention data available to plot.";
  }

  return {
    status,
    title,
    description,
    data: retention,
    warnings,
    units: {
      waterContent: CHART_UNITS.volPercent,
      tension: "kPa",
    },
    source,
    accessibilitySummary,
  };
}
